<template>
  <div class="clean-layout cleanContainer print">
    <v-container id="cleanContainer" class="mt-3" fluid v-if="file.is_shared">
      <v-layout align-items-center justify-content-center column>
        <v-flex v-if="file_loaded" class="text-xs-center">
          <vue-qr :callback="triggerPrint" :margin="0" :bgSrc="this.QRlogo" :logoScale="0.2" :text="magicLinkURL()" :size="200"></vue-qr>
        </v-flex>

        <v-flex class="pt-4 print-content">
          <v-card class="mx-auto">
            <v-card-title class="justify-center print-title">
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN0W3nlPwAFxALEyvQqGAAAAABJRU5ErkJggg==">
              <h1>{{$tf('Magic Link')}}</h1>
            </v-card-title>
            <v-card-text class="ml-3">
              <ul>
                <li>{{$tf('With this code you can access your medical test')}}</li>
                <li>{{$tf('In order to use it, you just have to scan it from any mobile phone')}}</li>
                <li>
                  {{$tf('You can also view your test the following URL and PIN')}}
                  <v-layout class="mt-1 mx-3" row wrap>
                    <v-flex xs12 class="body-2 link mt-2">
                      <div class="data mb-1">
                        <span class="key">{{$tf('Link')}}</span>
                        <span class="value">
                          <span class="text"><a :href=magicLinkURL()>{{magicLinkURL()}}</a></span>
                      </span>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6 class="body-2 ssid">
                      <div class="data">
                        <span class="key">{{$tf('PIN')}}</span>
                        <span class="value">
                          <span class="text">{{public_url.secure_id}}</span>
                        </span>
                      </div>
                    </v-flex>
                  </v-layout>
                </li>
              </ul>
            </v-card-text>

            <v-card-title class="justify-center print-title">
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN0W3nlPwAFxALEyvQqGAAAAABJRU5ErkJggg==">
              <h1>{{$tf("How this QR code is used")}}</h1>
            </v-card-title>
            <v-card-text class="ml-3">
              <ul>
                <li>{{$tf('In the vast majority of mobile phones you only need to open the phone\'s camera and point to the QR code with the logo in the title')}}</li>
                <li>{{$tf('If your mobile phone does not work with the instructions of the previous step you must use an specifc QR reading App')}}</li>
                <li>{{$tf('Otherwise you can always access with the URL and PIN described above')}}</li>
              </ul>


            </v-card-text>

            <v-card-actions class="print-footer">
              <p>* {{$tf('magic_link_notice')}}</p>
            </v-card-actions>
          </v-card>
        </v-flex>

      </v-layout>
    </v-container>

    <v-container id="cleanContainer" class="mt-5" fluid v-else-if="file_loaded">
      <v-layout align-items-center justify-content-center column>
        <v-card class="mx-auto error-card">
          <v-card-title class="justify-center print-title error-title">
            <h1 style="color:white;">Error</h1>
          </v-card-title>
          <v-card-text class="pa-5 text-xs-center" style="background: #ff525720; font-size: 1.2em;">
            {{$tf('Es posible que hayas accedido a esta página por error, el enlace al que estas accediendo no existe')}}
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import Api from '~/store/idonia-api/api'
  import VueQr from 'vue-qr'

export default {
    name: 'print-layout',
    components: {VueQr},
    data () {
      return {
        currentUrl: window.location.origin,
        msg: 'Welcome to Your Vue.js App',
        file: {},
        file_loaded: false,
        public_url: {},
        guestAuthList () {
          return this.$store.getters['session/guestAuthentication']
        },
        guestAuth () {
          return this.guestAuthList[this.$route.params.sha] || ''
        },
        magicLinkURL () {
          return this.currentUrl + '/v/' + this.public_url.namespace
        }
      }
    },
    computed: {
      fileId () {
        return parseInt(this.$route.params.id)
      }
    },
    props: {
      logo: {
        type: String,
        default: ''
      },
      QRlogo: {
        type: String,
        default: ''
      }
    },
    created () {
      this.file_loaded = false
      if (this.fileId) {
        Api.getV2('file/' + this.fileId).then(response => {
          this.file = response.body
          Api.getV2('file/' + this.fileId + '/shared').then(response => {
            this.public_url = (response.body.public_url && !response.body.public_url.is_expired) ? response.body.public_url : {}
            this.file_loaded = true
          })
        }).catch(error => {
          this.file_loaded = true
          console.log(error)
        })
      }
    },
    methods: {
      triggerPrint () {
        setTimeout(() => {
          window.print()
        }, 1)
      }
    }
}
</script>

<style lang="scss">
  .application--wrap {
    min-height: auto !important;
    height: auto !important;
  }

  html, body, #app {
    height: auto !important;
    min-height: auto !important;
    margin: 0 !important;
    padding: 0 !important;

    body {
      height: auto !important;
      max-height: none !important;
    }
  }

  .print {
    page-break-after: avoid;
    page-break-inside: avoid;
    margin-bottom: 0px;
  }

  .print-content {
    height: 690px;
  }

  .print-footer img {
    float: left;
    position: absolute;
    width: 100%;
    left: 0;
    height: 40px;
    margin: 0;
    padding: 0;
  }

  .print-footer p {
    font-size: 0.8em;
    position: relative;
  }

  li {
    font-size: 1.2em;
    padding: 6px;
  }

  .print-title img {
    float: left;
    position: absolute;
    width: 100%;
    height: 50px;
    left: 0;
  }

  .print-title h1 {
    position: relative;
    font-size: 1.5em;
  }

</style>


<style lang="scss" scoped>
  .error-card {
    max-width: 80%;
  }

  .error-title {
    background-color: var(--primary);
  }

  .data {
    display: inline-flex;
    flex-direction: row;
    background-color: rgba(0, 0, 0, .05);
    border-radius: 2px;
    overflow: hidden;
    font-size: 1.2rem !important;
    white-space: nowrap;
    max-width: 100%;

    @media screen and (max-width: 599px) {
      display: flex;
      position: relative;
    }

    .key {
      display: inline-block;
      padding: .5rem .8rem .5rem 1rem;
      background-color: rgba(0, 0, 0, .35);
      color: #fff;
      min-width: 5.5rem;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .value {
      display: inline-block;
      padding: .5rem 1rem .5rem .5rem;
      max-width: 100%;
      width: 100%;

      .text {
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 80%;

        @media screen and (max-width: 599px) {
          max-width: 85%;
          display: block;
        }
      }

      .action {
        display: inline-block;
        margin-left: 1rem;

        @media screen and (max-width: 599px) {
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          background-color: #eaeaea;
          height: calc(100% - 8px);
          margin: 4px 0 4px 3px;
          padding-right: 3px;
          width: 31px;
          text-align: center;
        }

        .btn {
          position: relative;
          width: 24px;
          height: 24px;
          vertical-align: bottom;
          margin: 0;

          @media screen and (max-width: 599px) {
            vertical-align: middle;
            margin: 3px 0 0 0;
            display: inline-block;
          }
        }

      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/CleanLayout.vue